import type { FaireProductEntity } from "../../entity_types/product";

export const p_t97wuxq6wg: FaireProductEntity = {
  token: "p_t97wuxq6wg",
  type: "product",
  name: "LM-SP-1000 Sherpa - Light Blue/Butter",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/d659d2fa1657e02174d1b0afb5fb9a90186d200f2960d6243765611c35306632.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f11e5d31a8efcb537984e39865fe2b5d8fb98d7ef8f3f115e05910d1ba49218c.jpeg"
  ],
  priceDollars: 39.5,
  description: "This Girlie Girl Originals sweatshirt features a sherpa-lined design in light blue and butter tones. Ideal for layering, it offers warmth with a comfortable silhouette and southern flair.",
  tags: [],
  msrpDollars: 79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:39.772Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
